import { EServiceId } from '../../../../../../../../types/reducers/publishTerms';
import { ECompetitorsPromotionType } from '../../../../../../../../reducers/v2';

export const isCompetitorSelected = (
  selectedService: EServiceId | null,
  competitorType: ECompetitorsPromotionType,
  isBetMoreThanTop: boolean,
): boolean => {
  switch (competitorType) {
    case ECompetitorsPromotionType.noPromotion:
      return selectedService === null;
    case ECompetitorsPromotionType.standard:
      return selectedService === EServiceId.paid;
    case ECompetitorsPromotionType.premium:
      return selectedService === EServiceId.premium;
    case ECompetitorsPromotionType.top:
      return selectedService === EServiceId.top && !isBetMoreThanTop;
    case ECompetitorsPromotionType.topWithBet:
      return selectedService === EServiceId.top && isBetMoreThanTop;
    default:
      return false;
  }
};
